// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","508":"browserHistory","826":"index","844":"noFound","910":"myPaper"}[chunkId] || chunkId) + "." + {"201":"9517fdd4","443":"c6b8b4eb","508":"bf76634b","770":"55e87a4e","826":"5ced4b66","844":"e7d9d937","910":"32f7d33d"}[chunkId] + ".js";
};